import { render, staticRenderFns } from "./WidgetNoData.vue?vue&type=template&id=dc48d04e&scoped=true"
import script from "./WidgetNoData.vue?vue&type=script&lang=js"
export * from "./WidgetNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc48d04e",
  null
  
)

export default component.exports